// Phase 25 iter-5e — users client.
//
// Backend (backend/src/routes/v1/users.ts):
//   GET   /api/v1/users/me  → ProfileResponse
//   PATCH /api/v1/users/me  → ProfileResponse  (name/dni/phone/vet_license/
//                                                entity_type/legal_name/fiscal_address)

import {
  API_VERSION_PREFIX,
  type ProfileResponse,
  type UpdateProfileRequest,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function getMyProfile(): Promise<ProfileResponse> {
  const { data } = await apiClient.get<ProfileResponse>(`${API_VERSION_PREFIX}/users/me`);
  return data;
}

export async function updateMyProfile(input: UpdateProfileRequest): Promise<ProfileResponse> {
  const { data } = await apiClient.patch<ProfileResponse>(`${API_VERSION_PREFIX}/users/me`, input);
  return data;
}
